<template>
  <panel>
    <wizard :title="title" :steps="steps" @changeStep="changeStep">
      <router-view @nextStep="nextStep" @previousStep="previousStep" />
    </wizard>
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel.vue';
import Wizard from '@/components/wizard/Wizard.vue';
import { wizardMixin } from '@/mixins/wizard';

// @vuese
// Dodawanie wzorów
// @group template
export default {
  components: { Panel },
  mixins: [wizardMixin('template')]
};
</script>
